import React from "react";
import { Modal, Descriptions, Spin } from "antd";
import { useQuery } from "@tanstack/react-query";
import { fetchWorker } from "../services/workersAPI";
import { formatDateTimeLocal } from "../utils/dateUtils";

const formatDataSource = (dataSource) => {
  const mapping = {
    rfi: "RFI",
    submittal: "Submittal",
    daily_report: "Daily Report",
  };
  return mapping[dataSource] || dataSource;
};

const ViewWorkerModal = ({ visible, onClose, workerId }) => {
  const { data: worker, isLoading } = useQuery({
    queryKey: ["worker", workerId],
    queryFn: () => fetchWorker(workerId),
    enabled: !!workerId,
  });

  return (
    <Modal
      title="View Worker"
      open={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      {isLoading ? (
        <div className="flex justify-center">
          <Spin />
        </div>
      ) : (
        <Descriptions column={1} bordered>
          <Descriptions.Item label="Name">{worker?.name}</Descriptions.Item>
          <Descriptions.Item label="Data Source">
            {formatDataSource(worker?.data_source)}
          </Descriptions.Item>
          <Descriptions.Item label="Prompt">{worker?.prompt}</Descriptions.Item>
          <Descriptions.Item label="Frequency">
            {worker?.frequency?.charAt(0).toUpperCase() +
              worker?.frequency?.slice(1)}
          </Descriptions.Item>
          <Descriptions.Item label="Start Date">
            {formatDateTimeLocal(worker?.start_date)}
          </Descriptions.Item>
          <Descriptions.Item label="Recipients">
            {worker?.report_to_emails?.join(", ")}
          </Descriptions.Item>
        </Descriptions>
      )}
    </Modal>
  );
};

export default ViewWorkerModal;
